export default __webpack_public_path__ + "assets/icons/apply-type.6437a09b.svg";